import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { SharedReviewView } from "./components/SharedReviewView";
import { ContractPicker } from "./components/ContractPicker";
import "./index.css";

const params = new URLSearchParams(window.location.search);
const reviewId = params.get("review");
const pickMode = params.get("pick");

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>{reviewId ? <SharedReviewView id={reviewId} /> : pickMode ? <ContractPicker /> : <App />}</React.StrictMode>
);
